/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandFunimation = createReactComponent("outline", "brand-funimation", "IconBrandFunimation", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M8 13h8a4 4 0 1 1 -8 0z", "key": "svg-1" }]]);

export { IconBrandFunimation as default };
//# sourceMappingURL=IconBrandFunimation.mjs.map
